/**
 * Created by valentin on 10/07/2017.
 */
import React from 'react'
import PropTypes from 'prop-types'

export default function PdfViewer (props) {
  return <iframe className='pdf-viewer' title={props.title} src={props.document} frameBorder='0' scrolling='auto' />
}

PdfViewer.propTypes = {
  title: PropTypes.string.isRequired,
  document: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/common/PDFViewer/PdfViewer.js